import { gql } from "@apollo/client";

export default gql`
  mutation updateCalibrationStatus(
    $complianceProgramId: Int!
    $targetId: Int!
    $status: ComplianceProgramCalibrationStatus!
  ) {
    updateComplianceProgramCalibrationStatus(
      complianceProgramId: $complianceProgramId
      targetId: $targetId
      status: $status
    ) {
      reportRow {
        id
        calibrationStatus
      }
    }
  }
`;
